import { getMutations, getState, getStateGetters } from './helper'

import { getActions } from './actions'
import TYPES from './mutation-types'
import mutations from './mutations'
import { getGetters } from './getters'
import state from './state'

export default {
  namespaced: true,
  state: { ...state, ...getState(TYPES) },
  getters: { ...getGetters(TYPES), ...getStateGetters(TYPES) },
  mutations: { ...mutations, ...getMutations(TYPES) },
  actions: getActions(TYPES),
}
